export default __webpack_public_path__ + "static/media/new.5f7c38d8.png";